import { createVanIconComponent } from "./van"

const Volume = createVanIconComponent("volume")
export default Volume
